import api from "./api";

export const getFeedback = (params = {}) => api.get("/feedback", { params });

export const giveFeedback = (payload) => api.post("/feedback", payload);

export const acknowledgeFeedback = (feedbackId) => api.post(`/feedback/${feedbackId}/acknowledge`);

export const getFeedbackRequests = (params = {}) => api.get("/feedback/requests", { params });

export const requestFeedback = (payload) => api.post("/feedback/requests", payload);

export const respondToFeedbackRequest = (requestId, payload) =>
  api.post(`/feedback/requests/${requestId}/respond`, payload);

export const declineFeedbackRequest = (requestId, payload) =>
  api.post(`/feedback/requests/${requestId}/decline`, payload);

export const getFeedbackSummary = (params = {}) => api.get("/feedback/summary", { params });

export const getFeedbackDirectory = () => api.get("/employees/feedback-directory");
